import styled from 'styled-components';
import { PaginatorTemplate } from './PaginatorTemplate';
import { rem } from 'polished';

export const PaginatorStyled = styled(PaginatorTemplate)`
    display: flex;
    justify-content: center;
    .pagination {
        outline: none;
        box-sizing: border-box;
        display: inline-block;
        padding-left: 0;
        margin: ${rem('20px')} 0;
        border-radius: ${rem('4px')};

        svg {
            width: 12px;
            height: 12px;
        }

        li {
            box-sizing: border-box;
            display: inline-block;
            a {
                box-sizing: border-box;
                cursor: pointer;
                position: relative;
                float: left;
                padding: ${rem('6px')} ${rem('12px')};
                margin-left: -${rem('1px')};
                color: ${({ theme }) => theme.colors.blue13};
                text-decoration: none;
                background-color: #fff;
                border: ${rem('1px')} solid #ddd;
            }
            &.active a {
                color: white;
                background-color: ${({ theme }) => theme.colors.blue13};
                border-color: ${({ theme }) => theme.colors.blue13};
            }
        }
    }
`;
